"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const STORAGE_KEYS_1 = __importDefault(require("../../../constants/app/STORAGE_KEYS"));
/**
 * Removes session cookie
 * call during logout
 */
function removeSessionCookie() {
    js_cookie_1.default.remove(STORAGE_KEYS_1.default.AUTH_COOKIE);
}
exports.default = removeSessionCookie;
